import { PostalDispatchService } from './../_services/postal-dispatch.service';
// import { selectProductsInitWaitingMessage } from './../_selectors/product.selectors';
// RxJS
import { Observable, of } from "rxjs";
import 'rxjs/add/observable/of';
import { catchError, delay, distinctUntilChanged, finalize } from 'rxjs/operators';
// CRUD
import { QueryResultsModel, BaseDataSource } from '../../_base/crud';
// State
import { Store, select } from '@ngrx/store';
import { AppState } from '../../reducers';
// Selectors

export class PostalDispatchsDataSource extends BaseDataSource {
  constructor(private postalDispatchService:PostalDispatchService) {
    super();
    // this.loading$ = this.store.pipe(
    //   select(selectPostalDispatchsPageLoading)
    // );

    // this.isPreloadTextViewed$ = this.store.pipe(
    //   select(selectPostalDispatchsShowInitWaitingMessage)
    // );

    // this.store.pipe(
    //   select(selectPostalDispatchsInStore)
    // ).subscribe((response: QueryResultsModel) => {
    //   this.paginatorTotalSubject.next(response.totalCount);
    //   this.entitySubject.next(response.items);
    // });
  }
  loadPageRequesed(page) {
    this.loading$ = Observable.of(true);
    this.isPreloadTextViewed$ = Observable.of(true);
    this.postalDispatchService.findPostalDispatchs(page).pipe(
      catchError(() => of([])),
      finalize(() => this.isPreloadTextViewed$ = this.loading$ = Observable.of(false),)
    ).subscribe(response => {
      this.loading$ = Observable.of(false);
      this.isPreloadTextViewed$ = Observable.of(false);
      const data = response['data'];
      this.paginatorTotalSubject.next(data.totalElements);
      this.entitySubject.next(data['content']);
    })
  }
}
